import React from 'react';
import { Link } from 'react-router-dom';
import { isLoaded, isEmpty } from 'react-redux-firebase';
import { useSelector } from 'react-redux';


function GameAdminList(props) {


    const auth = useSelector(state => state.firebaseReducer.auth)
    const { games } = props;
    let p = <div className="alert alert-info">...loading games.</div>;
    if (games && games.length > 0  && isLoaded(auth) && !isEmpty(auth) && games[0].ownerId === auth.uid) {
        p = <ul className="list-group">
            <li className="list-group-item" ><Link to="/game/create"><span className="glyphicon glyphicon-plus"></span> Create New Game</Link></li>
            {games.map(function (item, i) {
                return <li className="list-group-item" key={i} >
                    <div className="container-fluid">
                        <div className="row vertical-align">
                            <div className="col-xs-5">
                                {item.name} - {item.description}
                            </div>
                            <div className="col-xs-1">
                                <Link  to={`/play/${item.id}`} >
                                play&nbsp;me
                                </Link>
                            </div>
                            <div className="col-xs-2">
                                <Link className='btn btn-default btn-primary' to={`/players/admin/${item.id}`} >
                                    edit players
                            </Link>
                            </div>
                            <div className="col-xs-2">
                                <Link className='btn btn-default btn-info' to={`/game/edit/${item.id}`} >
                                    edit game
                            </Link>
                            </div>
                            <div className="col-xs-2">
                                <Link className='btn btn-danger' to={`/game/delete/${item.id}`}>
                                    delete game
                            </Link>
                            </div>

                        </div>
                    </div>
                </li>
            }
            )}
        </ul>;
    }
    else {
        p = <div><Link to="/game/create"> Create your first game</Link></div>;
    }

    return <div>
        {p}
    </div>;
}

export default GameAdminList;
